import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Crosshair, Crown, Trophy, UserRound } from 'lucide-react';
import useBullsEye from './useBullsEye';
import Game from './Game';
import Winners from './Winners';
import Leaderboard from './Leaderboard';
import Profile from './Profile';
import { SECTIONS } from './config';
import { TiersContext } from './components';
import { useT } from '../../i18n';

const TABS = [
  { key: 'game', label: 'bullseye.tabGame', icon: Crosshair },
  { key: 'winners', label: 'bullseye.tabWinners', icon: Trophy },
  { key: 'leaderboard', label: 'bullseye.tabLeaderboard', icon: Crown },
  { key: 'profile', label: 'bullseye.tabProfile', icon: UserRound },
];

/**
 * BullsEye: the whales-bet game, wearing the Luckblocks design system.
 *
 * One hook drives every tab so the four sections share a single polling loop
 * against the contract instead of each opening its own.
 */
const BullsEye = () => {
  const t = useT();
  const [searchParams] = useSearchParams();
  const requested = searchParams.get('section');
  const section = SECTIONS.includes(requested) ? requested : 'game';

  const game = useBullsEye();

  return (
    <div className="lb-page relative min-h-screen w-full px-2 py-8 sm:px-4 sm:py-10">
      <div className="relative mx-auto w-full max-w-screen-xl">
        <div className="lb-shell">
          <div className="flex w-full justify-center border-b border-white/5 px-4 py-4">
            <div className="lb-seg">
              {TABS.map((tab) => (
                <Link
                  key={tab.key}
                  to={`/bullseye?section=${tab.key}`}
                  data-active={section === tab.key}
                  aria-current={section === tab.key ? 'page' : undefined}
                  className="lb-seg-item"
                >
                  <tab.icon className="mr-2 inline h-4 w-4 align-[-2px]" aria-hidden="true" />
                  {t(tab.label)}
                </Link>
              ))}
            </div>
          </div>

          <TiersContext.Provider value={game.tiers}>
            <div className="w-full px-4 py-8 sm:px-8 sm:py-10">
              {section === 'game' ? <Game game={game} /> : null}
              {section === 'winners' ? <Winners game={game} /> : null}
              {section === 'leaderboard' ? <Leaderboard game={game} /> : null}
              {section === 'profile' ? <Profile game={game} /> : null}
            </div>
          </TiersContext.Provider>
        </div>
      </div>
    </div>
  );
};

export default BullsEye;
